import React from "react"
import { Field, FieldArray, InjectedFormProps, reduxForm } from "redux-form"
import { SurveyModel } from "../../../../../rpcs/dist/ChatRoomRPC"
import Color from "../../../../../style/enum/color"
import { Buttons, StyledButton, SurveyWrapper } from "../components/styles"
import { TitleInput } from "../components/title-input"
import { QuestionInput } from "./components/question-input"
import { validate } from "./validation"

export interface ICreateSelectSurveyProps {
  surveyModel: SurveyModel.Select
  title: string
  answers: string[]
}

interface ICustomProps {
  onBack: (ev: React.MouseEvent<HTMLButtonElement>) => void
}

const InitialValues: ICreateSelectSurveyProps = {
  surveyModel: SurveyModel.Select,
  title: "",
  answers: ["", ""],
}

const Form = (props: InjectedFormProps & ICustomProps) => {
  return (
    <SurveyWrapper>
      <form onSubmit={props.handleSubmit}>
        <Field name="surveyModel" type="hidden" component="input" />
        <Field
          name="title"
          type="text"
          component={TitleInput}
          placeholder="質問を入力してください"
        />
        <FieldArray name="answers" component={QuestionInput} />
        <Buttons>
          <StyledButton
            type="button"
            borderColor={Color.DIMGRAY}
            color={Color.DIMGRAY}
            onClick={props.onBack}
          >
            戻る
          </StyledButton>
          <StyledButton
            type="submit"
            backgroundColor={Color.BRAND}
            color={Color.WHITE}
          >
            送信
          </StyledButton>
        </Buttons>
      </form>
    </SurveyWrapper>
  )
}

export const CreateSelectSurvey = reduxForm<
  ICreateSelectSurveyProps,
  ICustomProps
>({
  form: "CreateSelectSurvey",
  validate,
  initialValues: InitialValues,
})(Form)
